import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const MyContactsIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.2606 24.2338V22.7292C25.2606 20.1796 23.2572 18.0898 20.7223 18.0898H16.9608C14.4668 18.0898 12.4225 20.1378 12.4225 22.7292V24.2338H25.2606Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8825 16.0416C21.0954 16.0416 22.8893 14.2077 22.8893 11.9456C22.8893 9.68344 21.0954 7.84961 18.8825 7.84961C16.6696 7.84961 14.8757 9.68344 14.8757 11.9456C14.8757 14.2077 16.6696 16.0416 18.8825 16.0416Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M28 2.5H6.65759V29.5H28V2.5Z"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 7.84961H9.1925"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16357 16.041H9.31519"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16357 24.2344H9.31519"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MyContactsIcon;
